import { FC, useMemo, CSSProperties } from "react";
import { getTeamColors } from "components/colors";
import { TennisScoreboard } from "./components/Scoreboard";
import { StatCharts } from "./components/StatCharts";
import {
  TennisStatus,
  extractPoints,
  extractSetEntries,
  extractTotals,
  parsePipeStats,
} from "./helper";
import { normalizeStats } from "./utils";

export const Stats: FC<{ status: TennisStatus }> = ({ status }) => {
  const { home: homeColor, away: awayColor } = getTeamColors(status as any);
  const courtData = useMemo(
    () => ((status as any)?.c ?? {}) as Record<string, unknown>,
    [status]
  );

  const setEntries = useMemo(() => extractSetEntries(courtData), [courtData]);
  const totals = useMemo(() => extractTotals(courtData), [courtData]);
  const points = useMemo(() => extractPoints(courtData), [courtData]);

  const statsEntries = useMemo(
    () => parsePipeStats(status?.sts),
    [status?.sts]
  );
  const normalizedStats = useMemo(
    () => normalizeStats(statsEntries),
    [statsEntries]
  );

  const chartStats = useMemo(
    () => normalizedStats.filter((stat) => stat.displayType === "chart"),
    [normalizedStats]
  );
  const lineStats = useMemo(
    () => normalizedStats.filter((stat) => stat.displayType === "line"),
    [normalizedStats]
  );

  const homeName = status?.T1?.n ?? status?.t1?.n ?? status?.T1n ?? "Home";
  const awayName = status?.T2?.n ?? status?.t2?.n ?? status?.T2n ?? "Away";

  const containerStyle = useMemo(
    () =>
      ({
        "--home-color": homeColor,
        "--away-color": awayColor,
      } as CSSProperties),
    [homeColor, awayColor]
  );

  return (
    <div
      className="flex w-full flex-col items-center gap-[3vw]"
      style={containerStyle}
    >
      <TennisScoreboard
        homeName={homeName}
        awayName={awayName}
        setEntries={setEntries}
        totals={totals}
        points={points}
      />

      <StatCharts chartStats={chartStats} lineStats={lineStats} />
    </div>
  );
};
